import React from 'react';
import './simpleSection.css';

interface SimpleSectionProps {
    children: React.ReactNode;
}

export const SimpleSection: React.FC<SimpleSectionProps> = ({ children }) => {
    return <div className="simple-section">{children}</div>;
};
